import { Component } from '@angular/core';

@Component({
  selector: 'ngx-footer',
  styleUrls: ['./footer.component.scss'],
  template: `
    <span class="created-by">&copy; <b><a href="http://www.automatizesistemas.com.br" target="_blank">Automatize sistemas</a></b> - 2018</span>
    <div class="socials">     
    </div>
  `,
})
export class FooterComponent {
}



// WEBPACK FOOTER //
// ./src/app/@theme/components/footer/footer.component.ts